export default __webpack_public_path__ + "static/media/cipolla.ff14a9c9.png";